<template>
  <div class="vx-row">
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
      :collapse-action="true">
      <div class="vx-row mb-3">
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm text-bold">General Search</label>
          <vs-input v-model="filters['search']" class="w-full mb-4 md:mb-0" />
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm text-bold">Action Category</label>
          <v-select :clearable="true" v-model="filters['ActionCategory']" multiple :options="action_categories"
            class="w-full">
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2" v-if="!id">
          <label class="text-sm text-bold">Company</label>
          <v-select :clearable="true" v-model="filters['Company']" :options="company_list" class="w-full" label="Name"
            :reduce="option => option._id" @input="onClickInputCompany()">
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm text-bold">Location</label>
          <v-select :clearable="true" v-model="filters['Location']" multiple :options="locations_list" class="w-full"
            label="Name" :reduce="option => option._id">
          </v-select>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm text-bold">Action Status</label>
          <v-select :clearable="true" v-model="filters['Status']" multiple :options="action_status_list" class="w-full">
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm text-bold">Risk Rating</label>
          <v-select :clearable="true" v-model="filters['riskRating']" :options="risk_rating_list" class="w-full">
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm text-bold">Person Responsible</label>
          <v-select :clearable="true" v-model="filters['PersonResponsible']" multiple :options="users_list"
            class="w-full" label="Name" :reduce="option => option._id">
          </v-select>
        </div>
        <div class="w-full vx-col md:w-1/4 sm:w-1/2">
          <label class="text-sm text-bold">Assessment Type</label>
          <v-select :clearable="true" v-model="filters['assessmentType']" :options="assessment_type_list"
            class="w-full" label="label" :reduce="option => option.value">
          </v-select>
        </div>
      </div>
      <div class="mt-5 vx-row">
        <div class="w-full ml-auto vx-col">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="onClickClearFilters">CLEAR
          </vs-button>
        </div>
      </div>
      <div class="mt-4 vx-row px-8 items-center compact-controls">

        <!-- Font size -->
        <div class="vx-col flex items-center mr-6 mb-4">
          <span class="control-label mr-2">Font</span>
          <vs-slider class="compact-slider" :min="8" :max="15" v-model="fontSize" @change="changeFontSize" />
          <span class="ml-2 value">{{ fontSize }}px</span>
        </div>

        <!-- Divider -->
        <div class="divider mx-4"></div>

        <!-- Columns -->
        <div class="vx-col flex flex-wrap items-center">
          <span class="control-label mr-3">Columns</span>

          <vs-checkbox v-for="col in columns" :key="col.key" v-model="col.visible" class="compact-checkbox">
            {{ col.label }}
          </vs-checkbox>
        </div>

      </div>
      <div class="float-right ml-auto mr-0 mb-2 font-bold">Total Records: {{ meta.totalRecords }} </div>
    </vx-card>

    <vx-card>
      <template slot="actions">
        <div class="flex float-right">
          <div class="con-btns-user flex items-center justify-between">
            <div class="flex mb-4">
              <vs-button v-if="!!id" @click.stop="onClickReportGenerate()" class="mr-4" color="danger" type="border">
                Generate Action Report
              </vs-button>
              <vs-button @click="onClickGeneratedReports" class="mr-4" color="primary" type="border">Generated
                Reports</vs-button>
              <vs-button v-can="'create-action'" @click="onClickCreateLocation" class="mr-4" color="primary"
                type="filled">New</vs-button>
            </div>
          </div>
        </div>
      </template>
      <div slot="no-body" class="mt-4" :style="{ '--app-font-size': fontSize + 'px' }">

        <vs-table :max-items="(meta.pageSize) ? meta.pageSize : 10" id="users-list" :data="actions_list"
          @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

          <template slot="thead">
            <vs-th class="resizable" v-if="isVisible('category')">
              Action Category
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('code')">
              Action Number
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('location')">
              Location
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('title')">
              Action Title
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('hazard')">
              Hazard
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('action')">
              Action
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('risk')">
              Risk Rating
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('status')">
              Status
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('logs')">
              Status Comments
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('due')">
              Due Date
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-if="isVisible('person')">
              Person Responsible
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
            <vs-th class="resizable" v-can="'update-action'">
              Action
              <span class="resize-handle" @mousedown="startResize($event, 0)"></span>
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="cursor-pointer">

              <vs-td v-if="isVisible('category')"> {{ tr.ActionCategory || '' }} </vs-td>
              <vs-td v-if="isVisible('code')">{{ tr.Code || 'N/A' }}</vs-td>
              <vs-td v-if="isVisible('location')"> {{ tr.Location.Name || '' }} </vs-td>
              <vs-td v-if="isVisible('title')"> {{ tr.ActionTitle || '' }} </vs-td>
              <vs-td v-if="isVisible('hazard')">{{ tr.Hazard || '' }}</vs-td>
              <vs-td v-if="isVisible('action')">{{ tr.Action || '' }}</vs-td>
              <vs-td v-if="isVisible('risk')">
                <vs-chip :color="generateRiskRating(tr.Consequence, tr.Likelihood).color">
                  {{ generateRiskRating(tr.Consequence, tr.Likelihood).rating }}</vs-chip>
              </vs-td>
              <vs-td v-if="isVisible('status')">
                <vs-chip :color="generateStatusColor(tr.Status)">{{ tr.Status ||
        '' }}</vs-chip>
              </vs-td>
              <vs-td v-if="isVisible('logs')">
                <p v-for="(log, index) in tr.statusLogs" :key="log._id" class="mb-1">
                  {{ __dateTimeFormatterToDate(log.createdAt) }}: {{ log.comments }}
                </p>
              </vs-td>
              <vs-td v-if="isVisible('due')"> {{ tr.DueDate || '' }} </vs-td>
              <vs-td v-if="isVisible('person')"> {{ tr.PersonResponsible ? `${tr.PersonResponsible.Name}` : '' }}
              </vs-td>
              <vs-td>
                <div class="flex">
                  <vx-tooltip v-can="'update-action'" class="mr-2" text="Update Action Status" position="top">
                    <vs-button @click.stop="onClickUpdateStatus(tr)" size="small" color="warning" type="filled"
                      icon-pack="feather" icon="icon-message-square"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-can="'update-action'" class="mr-2" text="Quick View & Update Action" position="top">
                    <vs-button @click.stop="onClickUpdate(tr)" size="small" color="warning" type="filled"
                      icon-pack="feather" icon="icon-edit"></vs-button>
                  </vx-tooltip>
                </div>
                <div class="flex mt-2">
                  <vx-tooltip v-can="'update-action'" class="mr-2" text="Open Action" position="top">
                    <vs-button @click.stop="onClickOpen(tr._id)" size="small" color="primary" type="border"
                      icon-pack="feather" icon="icon-eye"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-can="'delete-action'" class="mr-2" text="Delete Action" position="top">
                    <vs-button @click.stop="onClickDeleteConfirm(tr._id)" size="small" color="danger" type="border"
                      icon-pack="feather" icon="icon-trash-2"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>
        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.pageSize ? meta.pageSize : 20"
          :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
          description :description-items="descriptionItems" :total="(meta.totalPages) ? meta.totalPages : 0"
          v-model="page" class="p-5">
        </vs-pagination>
      </div>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" />
    <vs-prompt @cancel="() => { status_change_form = {} }" @accept="onClickChangeStatus" @close="activePrompt = false"
      :title="`Action Status Update: ${selected_action_for_update.Code}`" :accept-text="'Confirm'" :color="'primary'"
      :active.sync="activePrompt" :is-valid="isValidReason">
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <small class="label">Change To</small>
          <v-select :clearable="true" v-model="status_change_form.status" :options="action_status_list" class="w-full">
          </v-select>
        </div>
        <div class="vx-col w-full mb-3">
          <small class="label">Comment</small>
          <vs-textarea v-model="status_change_form.comments" class="w-full custom-textarea" ref="commentsTextarea"
            @input="autoResizeTextarea" @mouseup="captureManualResize" :height="textareaHeight" />
        </div>
        <div class="vx-col w-full mb-3">
          <small class="label">Due Date</small>
          <flat-pickr v-model="status_change_form.DueDate" placeholder="" class="w-full" />
        </div>
      </div>
    </vs-prompt>

    <!-- action report download with two branding prompt  -->
    <vs-prompt @cancel="() => { activePromptActionBranding = false }" @accept="onClickDownloadActionReport"
      @close="activePromptActionBranding = false" :title="`Action Report Brandings`" :accept-text="'Download'"
      :color="'primary'" :active.sync="activePromptActionBranding">
      <div class="vx-col w-full mb-3">
        <small class="label">Select Brand</small>
        <v-select :options="[{ label: 'Victual', value: 'victual' }, { label: 'RM4C', value: 'rm4c' }]"
          v-model="selected_report_branding" label="label" :reduce="option => option.value"></v-select>
      </div>
    </vs-prompt>

    <AssessmentReportGeneratePopUp ref="AssessmentReportGeneratePopUp"
      @openGeneratedReports="onClickGeneratedReports()" />
    <GeneratedReportsPopUp ref="GeneratedReportsPopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';

const TenantRepository = RepositoryFactory.get('tenant')
const ObjectRepository = RepositoryFactory.get('object')
const DropDownRepository = RepositoryFactory.get('drop_down')
const ActionRepository = RepositoryFactory.get('action');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"
import AssessmentReportGeneratePopUp from "@/components/popups/generate-reports/AssessmentReportGeneratePopUp.vue"
import GeneratedReportsPopUp from "@/components/popups/generated-reports/GeneratedReportsPopUp.vue"

import axios from "@/axios";
import { defaultPagination, perPageList } from "@/constants/config";
import { getRiskRating } from '@/constants/utils/riskUtils';
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'TenantContacts',
  data() {
    return {
      actions_list: [],
      id: '',
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      object_name: 'action',
      action_categories: [
        "None",
        "Risk Improvement",
        "Risk Control",
        "Underwriting Report",
        "Safety Improvement",
        "Safety Control",
        "None-Conformance",
        "External Audit Action",
        "Food Safety",
        "Desktop Review",
      ],
      action_status_list: [
        "New",
        "In Progress",
        "Complete",
        "Outstanding",
        "Not Accepted",
      ],
      locations_list: [],
      company_list: [],
      users_list: [],
      risk_rating_list: [
        "Low",
        "Medium",
        "High",
        "Extreme",
      ],
      status_change_form: {
        status: '',
        comments: ''
      },
      activePrompt: false,
      selected_action_for_update: {},
      activePromptActionBranding: false,
      selected_report_branding: 'victual',
      fontSize: 10,
      columns: [
        { key: 'category', label: 'Action Category', visible: true },
        { key: 'code', label: 'Action Number', visible: true },
        { key: 'location', label: 'Location', visible: true },
        { key: 'title', label: 'Action Title', visible: true },
        { key: 'hazard', label: 'Hazard', visible: true },
        { key: 'action', label: 'Action', visible: true },
        { key: 'risk', label: 'Risk Rating', visible: true },
        { key: 'status', label: 'Status', visible: true },
        { key: 'logs', label: 'Status Comments', visible: true },
        { key: 'due', label: 'Due Date', visible: true },
        { key: 'person', label: 'Person Responsible', visible: true },
      ],
      textareaHeight: 150,
      manualResized: false,
      assessment_type_list: [
        { label: 'Property Risk Assessment', value: 'PropertyRiskAssessment' },
        { label: 'COPE Assessment', value: 'CopeAssessment' },
        { label: 'Hazard Inspection', value: 'HazardInspection' },
        { label: 'Food Safety Report', value: 'FoodSafetyReport' }
      ]
    }
  },
  props: {
    company_name: {
      required: true,
      type: String
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    this.setFilterId('actions_list', ['search', 'ActionCategory', 'Company', 'Location', 'Status', 'riskRating', 'PersonResponsible'])
    if (this.id) {
      this.purgeFilters(['Company', 'Location']);
    }
    await this.fetchDropdownData()
  },
  components: {
    CreateObjectPopUp,
    'v-select': vSelect,
    flatPickr,
    AssessmentReportGeneratePopUp,
    GeneratedReportsPopUp
  },
  methods: {
    async fetchDropdownData() {
      await this.fetchLocationsList()
      await this.fetchUsersList()
      if (!this.id) {
        await this.fetchCompanyList()
      }
    },
    async refreshData() {
      await this.fetchActionList()
    },
    async fetchActionList() {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = (await TenantRepository.getActionList(this.page, this.filterQuery, this.perPage, this.sort, this.id)).data
        this.actions_list = data.data
        this.meta = data.pagination
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickCreateLocation() {
      await this.$refs.createObjectPopUp.openPopup(this.object_name, 'create', this.id ? { Company: this.id } : {})
    },
    async onClickDownload() {
      this.activePromptActionBranding = true
    },
    async onClickDownloadActionReport() {
      try {
        this.$vs.loading()
        const response = await axios.get(`${this.object_name}/${this.id}/report?brand=${this.selected_report_branding}`, {
          responseType: 'blob'
        });

        // Create a Blob from the response
        const file = new Blob(
          [response.data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );

        // Create download link
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', `${this.company_name} - Action Status Report.xlsx`); // Set file name here
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        URL.revokeObjectURL(fileURL);

        this.$vs.loading.close();
      } catch (e) {
        console.error(e);
        this.$vs.loading.close();
      } finally {
        this.selected_report_branding = 'victual'
        this.activePromptActionBranding = false
      }
    },
    async onClickUpdate(data) {
      await this.$refs.createObjectPopUp.openPopup(this.object_name, 'update', data)
    },
    async onClickOpen(id) {
      await this.$router.push({ path: `/pages/actions/${id}` })
    },
    async onClickResendEmail(email) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = await TenantRepository.resendTenantStaffUserWelcomeEmail(this.id, email)
        this.showSuccessMessage('Staff user welcome email send successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickDeleteConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        acceptText: 'Delete',
        text: `Are you sure you want to delete this action?`,
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(parama) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        await ObjectRepository.deleteObject(this.object_name, parama[0])
        this.fetchActionList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    filterQueryUpdate() {
      this.fetchActionList()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchActionList()
      }

    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    generateStatusColor(status) {
      switch (status) {
        case 'New':
          return '#37A7BE'
        case 'In Progress':
          return '#ffc000'
        case 'Complete':
          return '#70ad47'
        case 'Outstanding':
          return '#FF0000'
        case 'Not Accepted':
          return 'danger'
        default:
          return 'dark'
      }
    },
    generateRiskRating(consequence, likelihood) {
      return getRiskRating(consequence, likelihood);
    },
    async fetchLocationsList() {
      try {
        const { data } = (await DropDownRepository.fetchObjectsList('location', `account_id=${this.id ? this.id : (this.filters.Company ? this.filters.Company : '')}`)).data
        // this.filters.Company
        this.locations_list = data.data
      } catch (e) {
        console.log(e);
      }
    },
    async fetchUsersList() {
      try {
        const { data } = (await DropDownRepository.fetchObjectsList('contact', `account_id=${this.id ? this.id : (this.filters.Company ? this.filters.Company : '')}`)).data
        this.users_list = data.data
      } catch (e) {
        console.log(e);
      }
    },
    onClickUpdateStatus(data) {
      this.selected_action_for_update = data
      this.status_change_form.DueDate = data.DueDate
      this.activePrompt = true
    },
    async onClickChangeStatus() {
      try {
        await ActionRepository.updateActionStatus(this.object_name, this.selected_action_for_update._id, this.status_change_form)
        this.activePrompt = false
        await this.fetchActionList()
        this.status_change_form = {
          status: '',
          comments: ''
        }
      } catch (error) {

      }
    },
    async fetchCompanyList() {
      try {
        const { data } = (await DropDownRepository.fetchObjectsList('account')).data
        this.company_list = data.data
      } catch (e) {
        console.log(e);
      }
    },
    changeFontSize(value) {
      this.fontSize = value
    },
    async onClickInputCompany() {
      await this.fetchDropdownData()
    },
    async onClickClearFilters() {
      this.filters = {}
      await this.fetchDropdownData()
    },
    async onClickReportGenerate() {
      this.$refs.AssessmentReportGeneratePopUp.openPopup({
        _id: this.id,
        Code: this.company_name,
        Name: this.company_name
      }, this.object_name)
    },
    async onClickGeneratedReports() {
      await this.$refs.GeneratedReportsPopUp.openPopup(this.object_name)
    },
    startResize(e) {
      this.resizing = true
      this.currentTh = e.target.parentElement
      this.startX = e.pageX
      this.startWidth = this.currentTh.offsetWidth

      this.currentTh.classList.add('resizing')

      document.addEventListener('mousemove', this.resizeColumn)
      document.addEventListener('mouseup', this.stopResize)
    },
    resizeColumn(e) {
      if (!this.resizing) return
      const newWidth = this.startWidth + (e.pageX - this.startX)
      this.currentTh.style.width = newWidth + 'px'
    },
    stopResize() {
      this.resizing = false

      if (this.currentTh) {
        this.currentTh.classList.remove('resizing')
      }

      document.removeEventListener('mousemove', this.resizeColumn)
      document.removeEventListener('mouseup', this.stopResize)
    },
    isVisible(key) {
      return this.columns.find(c => c.key === key).visible
    },
    autoResizeTextarea() {
      this.$nextTick(() => {
        if (this.manualResized) return

        const el = this.getNativeTextarea()
        if (!el) return

        el.style.height = 'auto' // CRITICAL
        const newHeight = el.scrollHeight

        this.textareaHeight = newHeight
      })
    },

    captureManualResize() {
      this.$nextTick(() => {
        const el = this.getNativeTextarea()
        if (!el) return

        this.textareaHeight = el.offsetHeight
        this.manualResized = true
      })
    },

    getNativeTextarea() {
      const ref = this.$refs.commentsTextarea
      if (!ref) return null

      if (ref.$el) {
        return ref.$el.querySelector('textarea')
      }

      return null
    }
  },
  watch: {
    page() {
      this.fetchActionList()
    },
    perPage() {
      this.fetchActionList()
    }
  },
  computed: {
    isValidReason() {
      if (!this.status_change_form.status) {
        return false
      }
      // return this.status_change_form.comments.length > 2;
    },
    visibleColumns() {
      return this.columns.filter(c => c.visible)
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>
* {
  font-size: var(--app-font-size) !important;
}

.resizable {
  position: relative;
}

/* The draggable area */
.resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  /* easier to grab */
  height: 100%;
  cursor: col-resize;
  z-index: 10;
}

/* Visible vertical line */
.resize-handle::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 10%;
  height: 80%;
  width: 2px;
  background-color: rgba(255, 255, 255, 0.3);
  /* adjust for dark table */
  transition: all 0.2s ease;
}

/* Hover effect (important for UX) */
.resizable:hover .resize-handle::before {
  background-color: #c6c4c4;
  /* highlight color */
  width: 1px;
}

/* While dragging */
.resizing .resize-handle::before {
  background-color: #353535;
  width: 1px;
}

.custom-textarea {
  resize: vertical !important;
}

.compact-controls {
  background: rgba(255, 255, 255, 0.015);
  border-radius: 6px;
  padding: 8px 12px;
}

/* labels */
.control-label {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* slider */
.compact-slider {
  width: 120px;
}

/* value text */
.value {
  font-size: 11px;
  opacity: 0.7;
}

/* checkboxes */
.compact-checkbox {
  margin-right: 10px;
  margin-bottom: 4px;
  font-size: 11px;
  opacity: 0.85;
}
</style>
